import { createEffectHook } from '../factories/createEffectHook'
import { TypedEvent } from '../models/TypedEvent'

import type { Store } from '../stores/Store'

export interface StoreEventConstructor {
  new (...args: any[]): TypedEvent<Store>
}

/**
 * Store 挂载时触发
 */
export class MountStoreEvent extends TypedEvent<Store> {
  type = 'onMountStore' as const
}

/**
 * Store 卸载时触发
 */
export class UnmountStoreEvent extends TypedEvent<Store> {
  type = 'onUnmountStore' as const
}

export const { onMountStore, onMountStoreCapture } =
  createEffectHook(MountStoreEvent)
export const { onUnmountStore, onUnmountStoreCapture } =
  createEffectHook(UnmountStoreEvent)

declare global {
  export interface RehajeTypedEvents {
    onMountStore: MountStoreEvent
    onUnmountStore: UnmountStoreEvent
  }
}
